import * as Sentry from '@sentry/react'

const dsn = process.env.SENTRY_DSN
const environment = process.env.APP_ENV || 'development'

// Initialize sample rates with default values
let tracesSampleRate = 0.1
let replaysSessionSampleRate = 0.1
let replaysOnErrorSampleRate = 1.0

if (environment === 'development') {
  tracesSampleRate = 1.0
  replaysSessionSampleRate = 1.0 // 100% sessions for session replay
  replaysOnErrorSampleRate = 1.0 // 100% sessions where errors occur
} else if (environment === 'production') {
  tracesSampleRate = 0.1 // Example: 10% of transactions for performance monitoring
  replaysSessionSampleRate = 0.05 // Example: 5% of sessions for session replay
  replaysOnErrorSampleRate = 1.0 // Still 100% for sessions where errors occur to ensure all issues are captured
}

// Detect errors originating from third-party scripts injected by in-app
// browsers (e.g. Facebook WebView's contact autofill bridge). These errors
// are not actionable because they come from code we don't control.
const THIRD_PARTY_FRAME_PATTERNS = [
  /setContactAutofillValuesFromBridge/,
]

function isThirdPartyError(event: Sentry.ErrorEvent): boolean {
  const frames =
    event.exception?.values?.[0]?.stacktrace?.frames
  if (!frames?.length) return false

  return frames.some((frame) => {
    const fn = frame.function ?? ''
    return THIRD_PARTY_FRAME_PATTERNS.some((re) => re.test(fn))
  })
}

if (process.env.NODE_ENV !== 'test') {
  Sentry.init({
    dsn,
    environment,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate,
    // Session Replay
    replaysSessionSampleRate,
    replaysOnErrorSampleRate,
    beforeSend(event) {
      if (isThirdPartyError(event)) return null
      return event
    },
  })
}

export default Sentry
